import { makeStyles } from '@material-ui/core/styles';
import { DSTheme } from '../../styles/themes/types';

export default makeStyles((theme: DSTheme) => ({
  sideNav: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '545px',
    maxHeight: '928px',
    position: 'fixed',
    background: theme.palette.background.navigation,
    zIndex: 1000,

    width: '64px',
    height: 'calc(100vh - 96px)',
    padding: '48px 8px',

    [theme.breakpoints.up('md')]: {
      width: '242px',
      padding: '48px 40px',
    },
  },
  sideNavMenu: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginTop: '35px',

    [theme.breakpoints.up('md')]: {
      marginTop: '50px',
    },
  },
  sideNavMenuItem: {
    display: 'flex',
    flexDirection: 'row',
    color: theme.palette.text.navigation,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',

    paddingLeft: 0,
    width: '64px',
    height: '64px',

    [theme.breakpoints.up('md')]: {
      width: '216px',
      paddingLeft: '24px',
      justifyContent: 'flex-start',
    },
  },
  sideNavMenuItemSelected: {
    color: theme.palette.text.primary,
    background: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    paddingLeft: 0,
    height: '64px',
    width: '64px',
    borderRadius: 16,

    [theme.breakpoints.up('md')]: {
      width: '192px',
      paddingLeft: '24px',
      justifyContent: 'flex-start',
    },
  },
  sideNavSpacer: {
    height: '100vh',
    minWidth: '100px',

    [theme.breakpoints.up('md')]: {
      minWidth: '322px',
    },
  },
  sideMenuIcon: {
    marginRight: 0,
    marginTop: '4px',

    [theme.breakpoints.up('md')]: {
      marginRight: '10px',
    },

    '& img': {
      filter: 'invert(50%)',
      width: '24px',
      height: '24px',
    },
  },
  sideNavMenuItemText: {
    width: '132px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  sideNavMenuItemTextSelected: {
    width: '132px',
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  logo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '27px',

    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
    },

    '& svg': {
      minHeight: '27px',
    },
  },
  betaText: {
    width: '100%',
    maxWidth: '160px',

    textAlign: 'center',
    letterSpacing: '-0.045em',
    marginTop: '4px',

    color: '#49B8FF',
  },
  adminPortalText: {
    width: '100%',
    maxWidth: '160px',

    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '10px',
    marginTop: '4px',
  },
}));
